var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonAnalyticsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:analytics-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1562 16.9531L25.3125 11.625M13.5938 13.0781L17.3438 16.9531M4.6875 19.375L10.7812 13.0781",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.7188 11.625C27.4954 11.625 28.125 10.9744 28.125 10.1719C28.125 9.36934 27.4954 8.71875 26.7188 8.71875C25.9421 8.71875 25.3125 9.36934 25.3125 10.1719C25.3125 10.9744 25.9421 11.625 26.7188 11.625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.75 19.8594C19.5267 19.8594 20.1562 19.2088 20.1562 18.4062C20.1562 17.6037 19.5267 16.9531 18.75 16.9531C17.9733 16.9531 17.3438 17.6037 17.3438 18.4062C17.3438 19.2088 17.9733 19.8594 18.75 19.8594Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.1875 13.0781C12.9642 13.0781 13.5938 12.4275 13.5938 11.625C13.5938 10.8225 12.9642 10.1719 12.1875 10.1719C11.4108 10.1719 10.7812 10.8225 10.7812 11.625C10.7812 12.4275 11.4108 13.0781 12.1875 13.0781Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.28125 22.2812C4.0579 22.2812 4.6875 21.6307 4.6875 20.8281C4.6875 20.0256 4.0579 19.375 3.28125 19.375C2.5046 19.375 1.875 20.0256 1.875 20.8281C1.875 21.6307 2.5046 22.2812 3.28125 22.2812Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonAnalyticsOutline);
export default __webpack_public_path__ + "static/media/ion_analytics-outline.dc0b110816bf9e7950d44cad18e954ec.svg";
export { ForwardRef as ReactComponent };